// ── SafetyTrustSection ✦ — always-visible, never toggleable ─────
//
// Constitutional rules:
//   • Always renders — never hidden by a toggle.
//   • Positive framing only ("All suppliers are reviewed…") —
//     never problem-framed ("We check for bad actors").
//   • Each chip links into the existing /crew/trust anchors.
import React from 'react';
import { Link } from 'react-router-dom';
import {
  ShieldCheck, SealCheck, Lock, ArrowRight,
} from '@phosphor-icons/react';
import {
  PANEL_BORDER, TEXT, TEXT_MUTED, TEXT_SOFT, BLUE, VIOLET, SAGE,
} from './palette';
import { Section } from './Section';

export const SafetyTrustSection = ({ trust }) => {
  const rows = [
    { id: 'verified',  icon: SealCheck,   color: BLUE,
      label: trust.verified_suppliers || 'All suppliers are reviewed before posting.',
      anchor: 'verified' },
    { id: 'messaging', icon: Lock,        color: VIOLET,
      label: trust.messaging_safety || 'All messaging stays inside the app. Reportable in one tap.',
      anchor: 'messaging' },
    { id: 'under18',   icon: ShieldCheck, color: SAGE,
      label: trust.under18 || 'Quiet hours · safeguarding reviews · Designated Safeguarding Lead oversight.',
      anchor: 'under18' },
  ];

  return (
    <Section
      eyebrow="✦ Safety & Trust"
      title="How EventDrop looks after young crew"
      testid="parent-dashboard-trust"
      accent={SAGE}
    >
      {rows.map((t) => (
        <Link
          key={t.id}
          to={`/crew/trust#${t.anchor}`}
          data-testid={`parent-dashboard-trust-${t.id}`}
          style={{
            display: 'flex', alignItems: 'flex-start', gap: 12,
            padding: '12px 14px', borderRadius: 14, marginBottom: 8,
            background: 'rgba(255,255,255,0.025)',
            border: `1px solid ${PANEL_BORDER}`,
            color: TEXT, textDecoration: 'none',
          }}
        >
          <t.icon size={16} weight="fill" color={t.color} style={{ marginTop: 2, flexShrink: 0 }} />
          <span style={{ fontSize: 13.5, lineHeight: 1.55, color: TEXT_SOFT }}>
            {t.label}
          </span>
        </Link>
      ))}
      <Link
        to="/crew/trust"
        data-testid="parent-dashboard-trust-link"
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          marginTop: 6,
          padding: '10px 16px', borderRadius: 999,
          background: 'rgba(255,255,255,0.04)',
          border: `1px solid ${BLUE}45`,
          color: TEXT, textDecoration: 'none', fontWeight: 700, fontSize: 12.5,
        }}
      >
        <ShieldCheck size={13} weight="fill" color={BLUE} />
        View Trust Centre ✦
        <ArrowRight size={12} weight="bold" color={TEXT_MUTED} />
      </Link>
    </Section>
  );
};
